module.exports = __webpack_public_path__ + "videojs.flashls.swf";


//////////////////
// WEBPACK FOOTER
// ./~/videojs-swf/dist/video-js.swf
// module id = 77
// module chunks = 0